import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'stroke-curved', 'StrokeCurved', [["path",{"d":"M4 19h1.341a7 7 0 0 0 6.845 -5.533l.628 -2.934a7 7 0 0 1 6.846 -5.533h1.34"}]]);